export default __webpack_public_path__ + "static/media/28 Track 28.5a5667b0.mp3";